import api from './api';
class PlaylistDataService {
    getAll(data) {
        return api.get('playlists', { params: data });
    }
    get(id) {
        return api.get(`playlists/${id}`);
    }
    create(data) {
        return api.post('playlists', data);
    }
    update(id, data) {
        return api.put(`playlists/${id}`, data);
    }
}
export default new PlaylistDataService();
